export enum Permissions {
    Exam = 'ExamPermission',
    ExamFolder = 'ExamFolderPermission',
    ExamSchedule = 'ExamSchedulPermission',
    ExamViolations = 'ExamViolationsPermission',
    FormSetup = 'FormSetupPermission',
    QuestionsAndAnswers = 'QuestionsAndAnswersPermission',
    Report = 'ReportPermission',
    Summary = 'SummaryPermission',
    AddDelete = 'AddDeletePermission',
    Settings = 'SettingsPermission'
  }
  